import AlertsOffIcon from '@/assets/svg/conversations/alerts-off-16.svg?component';
import AlertsOnIcon from '@/assets/svg/conversations/alerts-on-16.svg?component';

export const ALERT_MENU_KEY = {
  NEXT: 'ArrowDown',
  PREVIOUS: 'ArrowUp',
  FIRST: 'Home',
  LAST: 'End',
} as const;

export const ALERT_NAVIGATION_KEYS = Object.values(ALERT_MENU_KEY);
export type AlertNavigationKey = (typeof ALERT_NAVIGATION_KEYS)[number];

export const ALERT_OPTIONS = [
  {
    label: 'Alerts on',
    value: true,
    description: 'Get notified when the candidate sends a new message.',
    icon: AlertsOnIcon,
  },
  {
    label: 'Alerts off',
    value: false,
    description: 'Stop notifications for new messages in this conversation.',
    icon: AlertsOffIcon,
  },
];
